import React, { Fragment, useEffect } from "react";
import Header from "../../components/Header/Header";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from "../../components/footer/Footer";
import OesPageHero from "./components/OesPageHero";
import OesIntroSection from "./components/OesIntroSection";
import OesWhatWeProvideSection from "./components/OesWhatWeProvideSection";
import OesAdvantagesSection from "./components/OesAdvantagesSection";
import OesHowItWorksSection from "./components/OesHowItWorksSection";
import OesModulesSection from "./components/OesModulesSection";
import WdevTestimonials from "../WebDevelopmentPage/components/WdevTestimonials";
import OesCtaBanner from "./components/OesCtaBanner";
import "../WebDevelopmentPage/web-development.css";
import "../HospitalManagementPage/hospital-management.css";
import "./online-exam.css";

const OnlineExamPage: React.FC = () => {
  useEffect(() => {
    document.title = "Online Exam Software | WebTech Software Solutions Bangalore";
    const description =
      "WebTech builds online examination software in Bangalore — question banks, AI proctoring, timed exams, auto-grading, and instant results for schools and colleges.";
    let meta = document.querySelector<HTMLMetaElement>('meta[name="description"]');
    if (!meta) {
      meta = document.createElement("meta");
      meta.name = "description";
      document.head.appendChild(meta);
    }
    meta.content = description;
  }, []);

  return (
    <Fragment>
      <div className="wdev-page inner-page">
        <div className="body_wrap o-clip">
          <Header />
          <main>
            <OesPageHero />
            <OesIntroSection />
            <OesWhatWeProvideSection />
            <OesAdvantagesSection />
            <OesHowItWorksSection />
            <OesModulesSection />
            <WdevTestimonials />
            <OesCtaBanner />
          </main>
          <Footer />
          <Scrollbar />
        </div>
      </div>
    </Fragment>
  );
};

export default OnlineExamPage;
